exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".merge-card{width:15rem}.merge-card ul.report-data li{margin-bottom:.5rem}.merge-card ul.report-data h6{margin:0}", ""]);

